export default __webpack_public_path__ + "static/sports-icon-e76e5d06b2cc2aaebf7dc89c2abc6f7e.png";